import { decode } from '@msgpack/msgpack/dist.umd/msgpack.min.js';
import $ from 'jquery';

const W = window;
const LS = W.localStorage;
const PREFIX = 'admin';

if (!Symbol.dispose) {
  Object.defineProperty(Symbol, 'dispose', {
    value: Symbol('dispose'),
    writable: false,
    enumerable: false,
    configurable: false,
  });
}

/* eslint-disable @stylistic/indent */
$.unpack = str =>
  str
    ? decode(
        W.atob(str)
          .split('')
          .map(c => c.charCodeAt(0)),
      )
    : {};
/* eslint-enable */

$.globalStorage = {
  remove: name => {
    LS.removeItem(`${PREFIX}:${name}`);
    return $.globalStorage;
  },

  get: (name, def) => {
    let value = LS.getItem(`${PREFIX}:${name}`);
    if (value) value = JSON.parse(value);
    return value || def;
  },

  set: (name, value) => {
    LS.setItem(`${PREFIX}:${name}`, JSON.stringify(value));
    return $.globalStorage;
  },
};

$.userStorage = {
  remove: name => {
    if (!W.AUTH || !W.AUTH.authenticated) return $.userStorage;

    LS.removeItem(`${PREFIX}:${W.AUTH.user.id}:${name}`);
    return $.userStorage;
  },

  get: (name, def) => {
    if (!W.AUTH || !W.AUTH.authenticated) return def;

    let value = LS.getItem(`${PREFIX}:${W.AUTH.user.id}:${name}`);
    if (value) value = JSON.parse(value);
    return value || def;
  },

  set: (name, value) => {
    if (!W.AUTH || !W.AUTH.authenticated) throw new Error('Unable to set storage when not authenticated');

    LS.setItem(`${PREFIX}:${W.AUTH.user.id}:${name}`, JSON.stringify(value));
    return $.userStorage;
  },
};
